var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "outer-black" }, [
    _c("div", { staticClass: "usecase-layout" }, [
      _vm._m(0),
      _vm._m(1),
      _c("div", { staticClass: "footer" }, [
        _c("div", { staticClass: "button-container" }, [
          _vm.availableKioskOrderModes.includes("inhouse")
            ? _c(
                "button",
                {
                  staticClass: "order-button px-4",
                  on: {
                    click: function ($event) {
                      return _vm.selectOption("inhouse")
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "icon",
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 64 64",
                        "aria-label": "Zum Hier essen",
                      },
                    },
                    [
                      _c("title", [_vm._v("Zum Hier essen")]),
                      _c("circle", {
                        attrs: {
                          cx: "32",
                          cy: "32",
                          r: "22",
                          fill: "none",
                          stroke: "#222",
                          "stroke-width": "3",
                        },
                      }),
                      _c("circle", {
                        attrs: {
                          cx: "32",
                          cy: "32",
                          r: "12",
                          fill: "none",
                          stroke: "#222",
                          "stroke-width": "2",
                        },
                      }),
                    ]
                  ),
                  _c("span", [_vm._v("Zum Hier essen")]),
                ]
              )
            : _vm._e(),
          _vm.availableKioskOrderModes.includes("takeAway")
            ? _c(
                "button",
                {
                  staticClass: "order-button px-4",
                  attrs: { "aria-label": "Zum Mitnehmen" },
                  on: {
                    click: function ($event) {
                      return _vm.selectOption("takeAway")
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "icon",
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 64 64",
                        role: "img",
                        "aria-hidden": "false",
                      },
                    },
                    [
                      _c("title", [_vm._v("Zum Mitnehmen")]),
                      _c("path", {
                        attrs: {
                          d: "M18 22\n               h28\n               l-4 32\n               h-20\n               l-4 -32\n               z",
                          fill: "none",
                          stroke: "#222",
                          "stroke-width": "3",
                          "stroke-linejoin": "round",
                        },
                      }),
                      _c("line", {
                        attrs: {
                          x1: "22",
                          y1: "40",
                          x2: "42",
                          y2: "40",
                          stroke: "#222",
                          "stroke-width": "1.5",
                          opacity: "0.9",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M26 22\n                   C26 14, 38 14, 38 22",
                          fill: "none",
                          stroke: "#222",
                          "stroke-width": "3",
                          "stroke-linecap": "round",
                        },
                      }),
                      _c("rect", {
                        attrs: {
                          x: "28",
                          y: "28",
                          width: "8",
                          height: "6",
                          rx: "1",
                          fill: "none",
                          stroke: "#222",
                          "stroke-width": "1.2",
                          opacity: "0.9",
                        },
                      }),
                    ]
                  ),
                  _c("span", [_vm._v("Zum Mitnehmen")]),
                ]
              )
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header" }, [
      _c("p", { staticClass: "welcome-text" }, [_vm._v("Willkommen bei")]),
      _c("img", {
        staticClass: "logo",
        attrs: { src: require("@/assets/placeholder6-opti.png"), alt: "Logo" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("main", { staticClass: "main" }, [
      _c("h1", { staticClass: "question" }, [
        _vm._v("Wie möchtest du deine Bestellung?"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }